export const SUBSCRIPTION = {
  SUBSCRIPTION_LOAD_CATEGORIES:"SUBSCRIPTION_LOAD_CATEGORIES",
  SUBSCRIPTION_LOAD_PRODUCTS:"SUBSCRIPTION_LOAD_PRODUCTS",
  SUBSCRIPTION_LOAD_CATEGORIES_DONE:"SUBSCRIPTION_LOAD_CATEGORIES_DONE",
  SUBSCRIPTION_LOAD_PRODUCTS_DONE:"SUBSCRIPTION_LOAD_PRODUCTS_DONE",
  SUBSCRIPTION_LOAD_CATEGORIES_FAIL:"SUBSCRIPTION_LOAD_CATEGORIES_FAIL",
  SUBSCRIPTION_LOAD_PRODUCTS_FAIL:"SUBSCRIPTION_LOAD_PRODUCTS_FAIL",
};

export const loadSubscriptionCategories = () => ({
  type: SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES,
});

export const loadSubscriptionCategoriesSuccess = categories => ({
  type: SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES_DONE,
  categories,
});

export const loadSubscriptionCategoriesFail = err => ({
  type: SUBSCRIPTION.SUBSCRIPTION_LOAD_CATEGORIES_FAIL,
  err,
});


export const loadSubscriptionProducts = (payload) => ({
  type: SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS,
  payload
});

export const loadSubscriptionProductsSuccess = products => ({
  type: SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS_DONE,
  products,
});

export const loadSubscriptionProductsFail = err => ({
  type: SUBSCRIPTION.SUBSCRIPTION_LOAD_PRODUCTS_FAIL,
  err,
});
